import { Flex, Layout, Space, Typography } from 'antd';
import React from 'react';

export const MainFooter = () => {
  return (
    <Layout.Footer
      style={{
        background: '#c82323',
        color: '#fff',
        padding: '30px 10%',
        width: '100%',
      }}
    >
      <Flex
        justify='space-between'
        align={'center'}
        wrap='wrap'
        style={{
          margin: '0 auto',
          padding: '0 24px',
        }}
      >
        <Typography.Text style={{ color: '#fff', fontSize: 14 }}>
          {`© Copyright ${new Date().getFullYear()} - mail alliance`}
        </Typography.Text>
        <Space size={24}>
          <Typography.Link
            style={{ color: '#fff', fontSize: 14 }}
            href={'https://www.mailalliance.net/datenschutz'}
            target='_blank'
          >
            Datenschutz
          </Typography.Link>
          <Typography.Link
            style={{ color: '#fff', fontSize: 14 }}
            href={'https://www.mailalliance.net/impressum'}
            target='_blank'
          >
            Impressum
          </Typography.Link>
          <Typography.Text style={{ color: '#fff', fontSize: 14 }}>
            Version: {import.meta.env.VITE_APP_VERSION} ({import.meta.env.MODE})
          </Typography.Text>
        </Space>
      </Flex>
    </Layout.Footer>
  );
};
